import { Routes } from '@angular/router';
import { supportShortInviteLinkMatcher } from './core/route-matchers/support-short-invite.matcher';
import { AuthGuard } from './core/guards/auth.guard';
import {
  appHomeRedirectGuard,
  organizationEmployeeChildGuard,
} from './core/guards/organization-employee.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'index',
    pathMatch: 'full',
  },
  {
    path: 'index',
    loadComponent: () =>
      import('./features/landing/landing.component').then((m) => m.LandingComponent),
  },
  {
    path: 'auth/action',
    loadComponent: () =>
      import('./features/auth-action-handler/auth-action-handler.component').then(
        (m) => m.AuthActionHandlerComponent
      ),
  },
  {
    path: 'invite/:shortId',
    loadComponent: () =>
      import('./features/invite-handler/invite-handler.component').then(
        (m) => m.InviteHandlerComponent
      ),
  },
  {
    matcher: supportShortInviteLinkMatcher,
    loadComponent: () =>
      import('./features/invite-handler/invite-handler.component').then(
        (m) => m.InviteHandlerComponent
      ),
  },
  {
    path: 'user-registration',
    loadComponent: () =>
      import('./features/user-registration/user-registration.component').then(
        (m) => m.UserRegistrationComponent
      ),
  },
  {
    path: 'app',
    loadComponent: () =>
      import('./layout/main-layout/main-layout').then((m) => m.MainLayout),
    canActivate: [AuthGuard],
    canActivateChild: [organizationEmployeeChildGuard],
    children: [
      {
        path: '',
        canActivate: [appHomeRedirectGuard],
        children: [],
      },
      {
        path: 'tickets',
        loadComponent: () =>
          import('./features/tickets/tickets-list.component').then(
            (m) => m.TicketsListComponent
          ),
      },
      {
        path: 'tickets/:ticketDocId/messages',
        loadComponent: () =>
          import('./features/tickets/ticket-messages-list.component').then(
            (m) => m.TicketMessagesListComponent
          ),
      },
      {
        path: 'tickets/:ticketDocId/messages/:messageDocId',
        loadComponent: () =>
          import('./features/tickets/ticket-message-detail.component').then(
            (m) => m.TicketMessageDetailComponent
          ),
      },
      {
        path: 'vendors',
        loadComponent: () =>
          import('./features/vendors/vendors-list.component').then(
            (m) => m.VendorsListComponent
          ),
      },
      {
        path: 'vendors/:id',
        loadComponent: () =>
          import('./features/vendors/vendor-detail/vendor-detail.component').then(
            (m) => m.VendorDetailComponent
          ),
      },
      {
        path: 'property-managers',
        loadComponent: () =>
          import('./features/property-managers/property-managers-list.component').then(
            (m) => m.PropertyManagersListComponent
          ),
      },
      {
        path: 'property-managers/:id',
        loadComponent: () =>
          import(
            './features/property-managers/property-manager-detail/property-manager-detail.component'
          ).then((m) => m.PropertyManagerDetailComponent),
      },
      {
        path: 'employees',
        loadComponent: () =>
          import('./features/employees/employees-list.component').then(
            (m) => m.EmployeesListComponent
          ),
      },
      {
        path: 'employees/add',
        loadComponent: () =>
          import('./features/employees/employee-detail/employee-detail.component').then(
            (m) => m.EmployeeDetailComponent
          ),
      },
      {
        path: 'employees/:id',
        loadComponent: () =>
          import('./features/employees/employee-detail/employee-detail.component').then(
            (m) => m.EmployeeDetailComponent
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/profile.component').then((m) => m.ProfileComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'index',
  },
];
